<template>
  <div class="clue">
    <div class="list-wrapper" v-show="clueList.length" ref="header">
      <scroller
        lock-x
        scrollerbar-y
        use-pullup
        ref="scroller"
        :height='scrollerHeight'
        :pullup-config="{content:'',upContent:'加载中...',downContent:'',loadingContent:'加载中...'}"
        @on-pullup-loading="loadMoreNotes"
      >
        <group class="clue_info-item" style="background-color: #eee;">
          <cell v-for="(item, index) in clueList" :key="item.id">
            <flexbox slot="after-title" class="clue-item-title" >
              <flexbox-item class="title">{{ item.source }}</flexbox-item>
              <flexbox-item class="value">{{ item.assign_time }}</flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex" >
              <flexbox-item class="name" :span="190/690">客户姓名</flexbox-item>
              <flexbox-item class="value">
                {{ item.customer_name }}
                <span v-if="item.customer_real_name">({{ item.customer_real_name }})</span>
              </flexbox-item>
              <flexbox-item class="clue-item-box">
                <div @click="showModifiedName(item.customer_id, index)" class="clue-item-button">补充真实姓名</div>
              </flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex">
              <flexbox-item class="name" :span="190/690">客户电话</flexbox-item>
              <flexbox-item class="value">
                <a class="mobile" :href="`tel:${item.customer_mobile_number}`">{{ item.customer_mobile_number }}</a>
              </flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex">
              <flexbox-item class="name" :span="190/690">推荐人姓名</flexbox-item>
              <flexbox-item class="value">{{ item.referrer_name }}</flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex">
              <flexbox-item class="name" :span="190/690">推荐人手机</flexbox-item>
              <flexbox-item class="value">
                <a class="mobile" :href="`tel:${item.referrer_mobile_number}`">{{ item.referrer_mobile_number }}</a>
              </flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex">
              <flexbox-item class="name" :span="190/690">领取时间</flexbox-item>
              <flexbox-item class="value">{{ item.receive_time }}</flexbox-item>
            </flexbox>
            <flexbox slot="after-title" class="info_flex">
              <flexbox-item class="name" :span="190/690">领取信息</flexbox-item>
              <flexbox-item class="value">
                <span v-for="(value, index) in item.receive_content" :key="value.coupon_id">
                  {{ value.title }}<i v-if="index !== item.receive_content.length - 1">、</i>
                </span>
              </flexbox-item>
            </flexbox>
          </cell>
          <divider class="bottom-line"  v-if="clueList.length && loadCompleted">我是有底线的</divider>
        </group>
      </scroller>
    </div>
    <p class="empty-data" v-if="!clueList.length">未搜索到该员工，请先添加员工账号</p>
    <confirm
      v-model="isShowDialog"
      title="请输入真实姓名"
      confirmText="确定"
      cancelText="取消"
      @on-confirm="confirmModifiedName"
      @on-hide="isShowDialog = false"
      @on-cancel="isShowDialog = false"
    >
      <section class="body">
        <x-input
          type="text"
          :max="6"
          v-model="modifiedName"
          placeholder="请输入姓名"
          class="order-id-input"
        ></x-input>
      </section>
    </confirm>
  </div>
</template>

<script>
import SalesNoteItem from '../components/SalesNoteItem'
import SearchInput from '../components/SearchInput'
import { Divider, Scroller, Group, Cell, Flexbox, FlexboxItem, XInput, Confirm } from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'
const camelCase = require('lodash.camelcase')

export default {
  components: {
    Divider,
    Scroller,
    Group,
    Cell,
    Flexbox,
    FlexboxItem,
    XInput,
    Confirm
  },
  data() {
    return {
      scrollerHeight: '',
      clueList: [],
      loadCompleted: false, // 标识列表项是否加载完成
      isShowDialog: false,
      modifiedName: '',
      customerId: 0,
      currentIndex: 0,
      params: {
        page: 1,
        count: 10
      }
    }
  },
  created () {
    this.getClueList()
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
  },
  methods: {
    async getClueList() {
      const res = await this.$rest.clue.getClueList(this.params)
      if (res.code === 0) {
        const newClueList = res.data.clues
        this.clueList = [...this.clueList, ...newClueList]
        const listLength = this.clueList.length
        this.$nextTick(() => { this.$refs.scroller.reset() })
        if (res.data.total_count === listLength) {
          this.loadCompleted = true
          this.$nextTick(() => { this.$refs.scroller.disablePullup() })
        } else {
          this.loadCompleted = false
          this.$nextTick(() => { this.$refs.scroller.enablePullup() })
        }
      } else {
        this.showToast(res.message)
      }
    },
    loadMoreNotes(done) {
      if (!this.loadCompleted) {
        this.params.page++
        this.getClueList()
      }
      done()
    },
    showModifiedName(id, index) {
      this.customerId = id
      this.currentIndex = index
      this.modifiedName = ''
      this.isShowDialog = true
    },
    async confirmModifiedName() {
      if (!this.modifiedName) {
        this.showToast('姓名不能为空')
        return
      }
      if (this.modifiedName.length > 6) {
        this.showToast('姓名太长')
        return
      }
      const { code, message } = await this.$rest.clue.modifyName(this.customerId)({ real_name: this.modifiedName })
      if (code !== 0) {
        this.showToast(message)
      }
      this.clueList[this.currentIndex].customer_real_name = this.modifiedName
      this.isShowDialog = false
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;
.clue {
  padding-bottom: 50/@w2;
  .list-wrapper{
    /deep/ .weui_cells{
      background-color: #eeeeee!important;
    }
    /deep/ .weui_cell:before, /deep/ .weui_cells:before, /deep/ .weui_cells:after{
      border: 0 solid #999!important;
      border-top: 0 solid #999!important;
      border-bottom: 0 solid #999!important;
    }
  }
  .weui_cell{
    width: 690/@w2;
    margin: 0 auto 20/@w2;
    padding: 0;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 0 20/@w2 0 rgba(158, 158, 158, 0.18);
    border-radius: 15/@w2;
    padding-bottom: 15/@w2;
  }
  .clue-item-title{
    background: #f8fafc;
    color: #333333!important;
    margin-bottom: 10/@w2;
    height: 90/@w2;
    line-height: 90/@w2;
    border-radius: 10/@w2;
    color: #333;
    .title{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 2 1 0;
    }
    .value{
      color: #999999;
      text-align: right;
    }
  }
  .vux-flexbox{
    padding: 0 20/@w2;
    box-sizing: border-box;
    color: #999999;
    .mobile{
      color: #999999;
    }
  }
  .clue-item-box{
    display: flex;
    justify-content: flex-end;
  }
  .clue-item-button{
    width: 180/@w2;
    height: 48/@w2;
    line-height: 48/@w2;
    text-align: center;
    background-color: #f1f8ff;
    border-radius: 24/@w2;
    border: solid 1px #409eff;
    font-size: 24/@w2;
    color: #409eff;
  }
  .vux-divider{
    margin-bottom: 100/@w2;
  }
  .empty-data{
    display: block;
    height: 60/@w2;
    line-height: 60/@w2;
    text-align: center;
  }
  .weui_dialog_bd{
    .weui_cell{
      width: 100%;
    }
  }
  .order-id-input {
    margin-top: 28/@w2;
    border-radius: 5px;
    border: solid 1px #d8dce6;
    &.weui_cell {
      padding: 10/@w2 20/@w2;
    }
    &.weui_cell:before {
      width: 0;
    }
  }
}
</style>
